const NextI18Next = require('next-i18next').default;

module.exports = new NextI18Next({
  defaultLanguage: 'en',
  // The product ships two languages. The switcher in layout/landing-v2/Footer.js
  // offers en and id, static/locales/ contains en and id, and every content
  // dictionary under static/ is keyed en and id. Advertising de/ar/zh/pt here
  // did not translate anything -- it only let a visitor's Accept-Language header
  // select a language nothing in this codebase can serve, which is how the whole
  // site came to answer 500 for German, Arabic, Chinese and Portuguese browsers
  // (172 of 41,654 requests in a day, 19 AUG 26), and why the pages that did
  // render showed raw keys like about_us instead of copy. Those visitors now get
  // the English site, which is what the product actually has.
  otherLanguages: ['id'],
  localeSubpaths: {
    id: 'id'
  },
  ignoreRoutes: ['/payment/', '/shares/', '/_next/', '/static/', '/challenge/', '/api/', '/aplikasi-olahraga', '/fitness-app', '/wearables/', '/.well-known/assetlinks.json', '/.well-known/apple-app-site-association', '/static*'],
});
